module.exports = __webpack_public_path__ + "static/media/website-01.a6716421.png";